var exports = {
  "kL": "HandoffCodeDisplay.module__container___dXQyTF",
  "DD": "HandoffCodeDisplay.module__title___dXQyTF",
  "h_": "HandoffCodeDisplay.module__description___dXQyTF",
  "w5": "HandoffCodeDisplay.module__expiredDescription___dXQyTF",
  "ZP": "HandoffCodeDisplay.module__codeSection___dXQyTF",
  "cg": "HandoffCodeDisplay.module__codeLabel___dXQyTF",
  "w8": "HandoffCodeDisplay.module__codeDisplay___dXQyTF",
  "IL": "HandoffCodeDisplay.module__codeChar___dXQyTF",
  "lr": "HandoffCodeDisplay.module__codeSeparator___dXQyTF",
  "O1": "HandoffCodeDisplay.module__timer___dXQyTF",
  "u1": "HandoffCodeDisplay.module__spinner___dXQyTF",
  "Fh": "HandoffCodeDisplay.module__spinnerIcon___dXQyTF",
  "z3": "HandoffCodeDisplay.module__error___dXQyTF",
};

module.exports = exports;
